var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"color":"blue","small":"","stretched":"","link":{ url: _vm.cardData.url, text: _vm.cardData.urlName }},scopedSlots:_vm._u([(_vm.cardData.isSubscribed)?{key:"top",fn:function(){return [_vm._v("Subscribed")]},proxy:true}:null],null,true)},[_c('h2',[_vm._v(_vm._s(_vm.cardData.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }